export default __webpack_public_path__ + "img/HourglassAnimationSlow-1838732f.gif";